module.exports = __webpack_public_path__ + "img/antes_despues_71.83dcaf58.png";